import type { ProjectListItem, ProjectNodePreview } from '../api/types'

/** Prefer designer images; show canvas images only if neither designer has a usable preview. */
export function projectPreviewCandidates(project: ProjectListItem): ProjectNodePreview[] {
  const designed = [
    ...(project.character_previews ?? []),
    ...(project.location_previews ?? []),
  ].filter((preview) => preview.image_path)
  const candidates = designed.length > 0
    ? designed
    : (project.image_previews ?? []).filter((preview) => preview.image_path)

  const seen = new Set<string>()
  return candidates.filter((preview) => {
    if (seen.has(preview.image_path)) return false
    seen.add(preview.image_path)
    return true
  })
}
